import { OverviewTabs } from './OverviewTabs'
import { withOverviewTabs } from './withOverviewTabs'

const ConnectedOverviewTabs = withOverviewTabs(OverviewTabs)

export { ConnectedOverviewTabs as OverviewTabs }
